export enum CarouselDataType {
  NONE = 'none',
  //Add more data type
}

export enum CarouselScrollBehavior {
  SNAP_TO_SLIDE = 'snapToSlide',
  CONTINUOUS_SCROLL = 'continuousScroll',
}

export enum CarouselActiveSlideAlignment {
  LEFT_ALIGNED = 'leftAligned',
  RIGHT_ALIGNED = 'rightAligned',
  AUTO_CENTERED = 'autoCentered',
}
